import { Relationships } from '@leverege/molten/data-source';
import { GlobalState } from '@leverege/ui-redux';
import { Types } from "../constants/index.js";
import DeviceTypeGroupDelegate from "../delegates/deviceType/DeviceTypeGroupDelegate.js";
export default {
  id: `${Types.deviceType}.loaderBlocker`,
  name: 'Load FOTA Device Types Blocker',
  sort: 0,
  matches: {
    client: 'GroupScreen',
    objectType: [Types.deviceGroup, Types.firmwareRelease, Types.firmwareApplication, Types.firmwareComponent]
  },
  execute: async cxt => {
    const {
      match
    } = cxt;
    const relationship = Relationships.getByPath('leverege.fotaApi.deviceType');
    const delegate = new DeviceTypeGroupDelegate({
      relationship,
      match
    });
    return GlobalState.dispatch(delegate.list());
  }
};